
let bazaarFix = (function() {
  return {
    erf:function (elements) {
      if (elements === undefined) {
        elements = document.getElementsByClassName('bv-inline-rating');
      }
      const isDarkTheme = typeof darkThemeFix_isDarkTheme !== 'undefined' && darkThemeFix_isDarkTheme;
      // alert("total " + elements.length);
      for (let i = 0; i < elements.length; i++) {
        let observer = new MutationObserver((mutationsList, observer) => {
          let foundZeroRating = false;
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              for (const node of mutation.addedNodes) {
                if (node && node.nodeType === Node.ELEMENT_NODE) {
                  foundZeroRating = this.updateRatingNumber(node, isDarkTheme);
                  if (foundZeroRating) {break;}
                  this.updateStarColor(node, isDarkTheme);
                }
              }
            }
            if (foundZeroRating) {
              mutation.target.style.setProperty("display", "none", 'important');
              break;
            }
          }
          observer.disconnect();
        });

        let target = elements[i];
        observer.observe(target, { childList: true, subtree: true });
      }
    },
    updateStarColor: function(node, isDarkTheme) {
      const lgs = node.getElementsByTagName('linearGradient');
      for (let i = 0; i < lgs.length; i++) {
        const stops = lgs[i].getElementsByTagName('stop');
        for (let j = 0; j < stops.length; j++) {
          const stop = stops[j];
          const colorToChange = stop.style.getPropertyValue('stop-color');
          if (colorToChange === 'rgb(214, 104, 55)') {
            if (isDarkTheme) {
              stop.style.setProperty('stop-color', '#C8A766', 'important');
            } else {
              stop.style.setProperty('stop-color', '#1F1A14', 'important');
            }
          }
        }
      }
    },
    updateRatingNumber: function(node, isDarkTheme) {
      const tmps = node.getElementsByClassName("bv_numReviews_component_container");
      let foundZeroRating = false;
      for (let j = 0; j < tmps.length; j++) {
        let jE = tmps[j];
        let bv = jE.getElementsByClassName("bv_text");
        for (let k = 0; k < bv.length; k++) {
          let bk = bv[k];
          if (bk.innerText === "(0)") {
            foundZeroRating = true;
            break;
          }
        }
        if (foundZeroRating) { break;}
      }

      if (!foundZeroRating && isDarkTheme) {
        let targetsAndStyleArray = [[".bv_text", "color", "#7e8c82"]];
        for (let m = 0; m < targetsAndStyleArray.length; m++) {
          let iter = targetsAndStyleArray[m];
          let elTargetsForColor = [];
          let targetStr = iter[0];
          let forcedStyle = iter[1];
          let forcedValue = iter[2];
          let targetsArr = targetStr.split(" ");
          for (let j = 0; j < targetsArr.length; j++) {
            let jT = targetsArr[j];
            let tmps = node.getElementsByClassName(jT.substring(1));
            elTargetsForColor = elTargetsForColor.concat(Array.from(tmps));
          }
          for (let k = 0; k < elTargetsForColor.length; k++) {
            let elem = elTargetsForColor[k];
            elem.style.setProperty(forcedStyle, forcedValue, 'important');
          }
        }
      }
      return foundZeroRating;
    },
    prc: function(){
      let elements = document.getElementsByClassName('product-recommendations');
      for (let i = 0; i < elements.length; i++) {
        let observer = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              for (const node of mutation.addedNodes) {
                if (node && node.nodeType === Node.ELEMENT_NODE) {
                  let cc = node.getElementsByClassName("bv-inline-rating");
                  this.erf(cc);
                }
              }
            }
          }
          observer.disconnect();
        });

        let target = elements[i];
        observer.observe(target, { childList: true, subtree: true });
      }
    }
  }
})();

(function() {
  if (document.readyState === "loading") {
    document.addEventListener('DOMContentLoaded', function (event) {
      bazaarFix.erf();
    });
  } else {
    bazaarFix.erf();
  }
})();



